/**
 * © 2025 Little Shilling, Inc.
 * Shon Little
 * Created: 2025-07-22
 */

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_FULL_BASE_URL } from '../../config/api';

// Contact form data interface
export interface ContactFormData {
  name: string;
  email: string;
  subject: string;
  message: string;
  turnstile_token: string;
}

// Contact form response interface
export interface ContactFormResponse {
  message: string;
  success: boolean;
  error?: string;
}

const baseUrl = API_FULL_BASE_URL;

// Create the contact API slice
export const contactApi = createApi({
  reducerPath: 'contactApi',
  baseQuery: fetchBaseQuery({ baseUrl }),
  tagTypes: ['Contact'],
  endpoints: builder => ({
    submitContactForm: builder.mutation<ContactFormResponse, ContactFormData>({
      query: formData => ({
        url: 'contact/',
        method: 'POST',
        body: formData,
      }),
    }),
  }),
});

export const { useSubmitContactFormMutation } = contactApi;
